module.exports = __webpack_public_path__ + "static/media/unknownAvatar.f457bb67.png";